import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.8a9.2 9.2 0 1 0 9.2 9.2H23A11 11 0 1 1 12 1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LoaderOutlinedSize24Glyph.displayName = 'LoaderOutlinedSize24Glyph';
